import React from 'react';
import './ProjectInProgress.css';

const ProjectInProgress = (props) => {
  return (
    <div className="projectInProgress-container">
      <div className="projectInProgress-center">
        <h2>{props.title}</h2>
      </div>
    </div>
  );
};

export default ProjectInProgress;
